import script from "./HomepageFavorites.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageFavorites.vue?vue&type=script&setup=true&lang=js"

import "./HomepageFavorites.vue?vue&type=style&index=0&id=294a5b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294a5b86"]])

export default __exports__